// Activity Tracking API
import api, { type AxiosResponse, type PaginatedResponse } from './client';
import type {
  UserActivityLog,
  ActivityStats,
  QueryParams,
} from './types';

export const activityAPI = {
  // Activity Logs
  getActivityLogs: (params?: QueryParams): Promise<AxiosResponse<PaginatedResponse<UserActivityLog>>> =>
    api.get('/core/activity-logs/', { params }),

  getActivityLog: (id: number): Promise<AxiosResponse<UserActivityLog>> =>
    api.get(`/core/activity-logs/${id}/`),

  getActivityStats: (): Promise<AxiosResponse<ActivityStats>> =>
    api.get('/core/activity-logs/stats/'),
};
